import { StyledContainer, StyledErrorMessage, StyledInput, StyledLabel, StyledRadioInputWrapper } from './radio-input-group.styles';
import { RadioInputGroupProps } from './radio-input-group.types';
export const RadioInputGroup = ({
  option,
  currentOption,
  onChange,
  isError,
  errorMessage,
  disabled,
  isTaskBreakdownSupported
}: RadioInputGroupProps) => {
  const handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!disabled) {
      const event = ({
        target: {
          value: option.value
        }
      } as React.ChangeEvent<HTMLInputElement>);
      onChange(event);
    }
  };
  return <StyledContainer $isError={isError} $disabled={!!disabled} $isChecked={currentOption === option.value} onClick={handleContainerClick} $isTaskBreakdownSupported={!!isTaskBreakdownSupported} data-sentry-element="StyledContainer" data-sentry-component="RadioInputGroup" data-sentry-source-file="radio-input-group.tsx">
      <StyledRadioInputWrapper data-sentry-element="StyledRadioInputWrapper" data-sentry-source-file="radio-input-group.tsx">
        <StyledInput type="radio" id={option.value} name={option.name} value={option.value} checked={currentOption === option.value} onChange={onChange} disabled={disabled} aria-invalid={isError} onClick={e => e.stopPropagation()} data-sentry-element="StyledInput" data-sentry-source-file="radio-input-group.tsx" />
        <StyledLabel disabled={disabled} htmlFor={option.value} data-sentry-element="StyledLabel" data-sentry-source-file="radio-input-group.tsx">
          {option.label}
        </StyledLabel>
      </StyledRadioInputWrapper>
      {isError && errorMessage && <StyledErrorMessage>{errorMessage}</StyledErrorMessage>}
    </StyledContainer>;
};